export function permissionKey(moduleName, action, fieldKey = null) {
  return [moduleName, action, fieldKey || ""].join(":");
}

export function policyKey(moduleName, action) {
  return [moduleName, action].join(":");
}

export function hasPermission(user, moduleName, action, fieldKey = null) {
  if (user?.isSuperAdmin) return true;

  const capabilities = user?.capabilities || null;
  if (capabilities && typeof capabilities === "object") {
    const key = permissionKey(moduleName, action, fieldKey);
    return capabilities[key] === true;
  }

  return false;
}

export function getPrimaryRoleName(user) {
  if (user?.effective_role_name) return user.effective_role_name;
  if (user?.role_name) return user.role_name;
  if (Array.isArray(user?.roles) && user.roles[0]?.name) return user.roles[0].name;
  return user?.role_id ? `Role #${user.role_id}` : "User";
}

export function getPolicySummary(user, moduleName, action) {
  return user?.policy_scope?.[policyKey(moduleName, action)] || null;
}
